import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const RecourseLicense = ({ roles }) => {

    return (
        <M_Table entityName={'ResourceLicense'} filtersOnTable rolePermissions={roles} />
    )
}